import styled from "styled-components";

export const Content = styled.div`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 4px;
    padding: 10px;
`;

export const Title = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Forms = styled.div`
`;

export const FormInput = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
        background-color: transparent;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_200};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const ButtonRemove = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.error};
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    box-shadow: 0px 1px 1px 0px ${(props) => props.theme.colors.gray.gray_100};
    
    padding: 4px 8px;
    border-radius: 30px;
    
    &:hover{
        background-color: ${(props) => props.theme.colors.white};
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-top: 16px;

    color: ${(props) => props.theme.colors.gray.gray_600};
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    padding: 4px 8px;
    border-radius: 30px;
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.white};

    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;